export const eng = {
    pokedexDescription: 'en',
    bigTitleOne: 'Search any Pokemon',
    firstCardDescription: 'Search for any Pokémon you want and know its main data, such as Skills, types and their habits.',
    bigTitleTwo: 'You can see all the pokemon registered in the pokedex from number one to the last',
    thirdCardDescription: 'Play mini-games about the interesting facts about each Pokemon, polish your knowledge about all these fantastic creatures',
    //navbar
    Home: "Home",
    Contact: "Contact",
    Games: "Games",
    lenguage: 'EN',

    //home page
    pokemonDay: "Featured Pokemon of the day",
    //game mode
    score: "Score",
    selectGameMode: "Select Game Mode",
    warmUp: 'Warm Up',
    arcade: "Arcade",
    descriptionWarmUp: "Relaxed game mode to practice your skills, with a maximum of 10 questions.",
    descriptionArcade: "Unlimited questions, the true test of your Pokémon knowledge.",
    selectButton: "select",
    //detail pokemon
    numDex: "National №",
    typesPkmn: "Types",
    Species: "Species",
    Weight: "Weight",
    Height: "Height",
    Abilities: "Abilities",
    Weak: "Weak",
    Resistant: "Resistant",
    Immunities: "Immunities",
    BaseStats: "Base Stats",
    hp: "hp",
    attack: "attack",
    defense: "defense",
    specialAttack: "special-attack",
    specialDefense: "special-defense",
    speed: "speed",
    EvolutionChart: "Evolution Chart",
    PokedexEntries: "Pokedex Entries",
    none: "none",
    bug: "bug",
    dark: "dark",
    dragon: "dragon",
    electric: "electric",
    fairy: "fairy",
    fighting: "fighting",
    fire: "fire",
    flying: "flying",
    ghost: "ghost",
    grass: "grass",
    grass: "grass",
    ice: "ice",
    normal: "normal",
    poison: "poison",
    psychic: "psychic",
    rock: "rock",
    steel: "steel",
    water: "water",

    //footer
    footerMsg: "This site is for educational purposes only and not for profit.",
}